// Shared catalog/schema naming-convention derivation logic, used by both the
// live per-catalog preview (CatalogsAndSchemasField) and the final review
// step (ReviewSummaryField) so they can never drift out of sync with each
// other. Mirrors packages/backend/src/scaffolder/deriveCatalogNaming.ts,
// which computes the same thing server-side when the request is actually
// created.

// Workspace names follow <prefix>-<shortname>-<tier>-<region>, e.g.
// 'adb-linttest-stg-we' -> 'linttest'. Falls back to the full workspace name
// if it doesn't have a second hyphen-separated segment to extract.
interface WorkspaceSelection {
  spoke?: string;
  environments?: string[];
}

const workspaceValue = (workspace?: string | WorkspaceSelection): string => {
  if (typeof workspace === 'string') return workspace;
  return workspace?.spoke ?? '';
};

export const deriveWorkspaceShortName = (
  workspace?: string | WorkspaceSelection,
): string => {
  const value = workspaceValue(workspace);
  const parts = value.toLowerCase().split('-');
  return parts.length > 1 ? parts[1] : value.toLowerCase();
};

export const deriveEnv = (workspace?: string | WorkspaceSelection): string => {
  if (typeof workspace === 'object') {
    return workspace.environments?.[0]?.toLowerCase() ?? '';
  }
  return workspace?.toLowerCase().includes('prod') ? 'prod' : 'stg';
};

export const computeCatalogNamePrefix = (
  workspace?: string | WorkspaceSelection,
  _team?: string,
): string => {
  const env = deriveEnv(workspace);
  const workspaceShortName = deriveWorkspaceShortName(workspace);
  return `${workspaceShortName}_${env}_`;
};
